import React from "react";
import ColabCard from "./ColabCard";
import "../style/ColabSection.css";
import centerForCybersecurityImg from "../assets/center.jpeg";
import csImg from "../assets/cs.jpeg";
import citImg from "../assets/cit.png";
import businessImg from "../assets/business.png";

const collaborators = [
  {
    name: "Center for Cybersecurity",
    url: "https://miamioh.edu/cec/centers-institutes/center-for-cybersecurity/index.html",
    icon: "🏢",
    backgroundImage: centerForCybersecurityImg,
  },
  {
    name: "Department of Computer Science & Software Engineering",
    url: "https://miamioh.edu/cec/departments/computer-science-software-engineering/index.html",
    icon: "🏢",
    backgroundImage: csImg,
  },
  {
    name: "Cybersecurity and Networking BS Program",
    url: "https://programs.miamioh.edu/programs/cybersecurity-and-networking-bs/",
    icon: "🎓",
    backgroundImage: citImg,
  },
  {
    name: "Information & Cybersecurity Management BS Program",
    url: "https://programs.miamioh.edu/programs/information-cybersecurity-management-bs/",
    icon: "🎓",
    backgroundImage: businessImg,
  },
];

const ColabSection = () => {
  return (
    <section className="colab-wrapper" id="collaborators">
      <h2 className="colab-title">Explore Our Resources</h2>
      <div className="colab-grid">
        {collaborators.map((collaborator, index) => (
          <ColabCard key={index} {...collaborator} />
        ))}
      </div>
    </section>
  );
};

export default ColabSection;
